import { ChangeEvent, FunctionComponent, useState } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import { Language } from '@/models/general';
import { SeoMetaData } from '@/models/seoMetaData';

type SeoMetaDataProps = {
    seoMetaData: SeoMetaData;
    onChange: (seoMetadata: SeoMetaData) => void;
};

export const SeoMetaDataBlock: FunctionComponent<SeoMetaDataProps> = ({
    onChange,
    seoMetaData,
}) => {
    const [localSeoMetaData, setLocalSeoMetaData] = useState(seoMetaData);

    const onChangeLocal =
        (name: keyof SeoMetaData) => (e: ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;

            setLocalSeoMetaData((prev) => ({
                ...prev,
                [name]: value,
            }));
        };

    const onPropagateChange = () => {
        onChange(localSeoMetaData);
    };

    return (
        <Box>
            <Typography
                sx={{
                    mb: 3,
                }}
                variant='h6'
            >
                Seo Meta Daten{' '}
                {seoMetaData.language === Language.DE ? 'Deutsch' : 'Englisch'}
            </Typography>

            <Stack
                sx={{
                    ml: 2,
                }}
                spacing={3}
            >
                <TextField
                    value={localSeoMetaData.title}
                    onChange={onChangeLocal('title')}
                    onBlur={onPropagateChange}
                    label='Titel'
                    autoComplete='off'
                    fullWidth
                />

                <TextField
                    value={localSeoMetaData.description}
                    onChange={onChangeLocal('description')}
                    onBlur={onPropagateChange}
                    label='Seo Beschreibung'
                    autoComplete='off'
                    fullWidth
                />

                <TextField
                    value={localSeoMetaData.slug}
                    onChange={onChangeLocal('slug')}
                    onBlur={onPropagateChange}
                    label='Seo Slug'
                    autoComplete='off'
                    fullWidth
                />
            </Stack>
        </Box>
    );
};
